import { render, staticRenderFns } from "./KnowledgeBaseExplorer.vue?vue&type=template&id=3ef0be34&scoped=true&"
import script from "./KnowledgeBaseExplorer.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseExplorer.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseExplorer.vue?vue&type=style&index=0&id=3ef0be34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef0be34",
  null
  
)

export default component.exports